import ReactGA from 'react-ga';
import React from 'react';
import * as routes from '../../constants/routes';
import { Menu, Icon, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { auth } from '../../firebase';

const SubMenu = Menu.SubMenu;

export const Home = (role) => {
  if (role === 'client' || role === 'admin') {
    return (
      <Menu.Item key="/client-portal/"><Link to={routes.CLIENTPORTAL}>
        <Icon type="pie-chart" />
        <span className="nav-text">Home</span></Link>
      </Menu.Item>
    )
  } else {
    return;
  }
}
export const Outline = (role) => {
  if (role === 'client' || role === 'admin') {
    return (
      <Menu.Item key="/client-portal/outline/"><Link to={routes.OUTLINE}>
        <Icon type="bars" />
        <span className="nav-text">Outline</span></Link>
      </Menu.Item>
    )
  } else {
    return;
  }
}
export const Bores = (role) => {
  if (role === 'client' || role === 'admin') {
    return (
      <Menu.Item key="/client-portal/bores/"><Link to={routes.BORES}>
        <Icon type="environment" />
        <span className="nav-text">Bores</span></Link>
      </Menu.Item>
    )
  } else {
    return;
  }
}
export const Calendar = (role) => {
  if (role === 'admin') {
    return (
      <Menu.Item key="/client-portal/calendar/"><Link to={routes.CALENDAR}>
        <Icon type="calendar" />
        <span className="nav-text">Calendar</span></Link>
      </Menu.Item>
    )
  } else {
    return;
  }
}
export const Fulcrum = (role) => {
  if (role === 'admin') {
    return (
      <Menu.Item key="/client-portal/fulcrum/" id="menuFulcrum">
        <Tooltip placement="right" title='Fulcrum will open in a new tab.'>
          <a href="https://web.fulcrumapp.com/dash/e328b1d1-cd10-46d5-87d8-ace3f02a3344" target="_blank" rel="noopener noreferrer" >
            <Icon type="up-square" />
            <span className="nav-text">Fulcrum</span>
          </a>
        </Tooltip>
      </Menu.Item>
    )
  } else {
    return;
  }
}
export const Timesheet = role => {
  if (role === 'admin') { return <Menu.Item key="/timesheets"><Link to={routes.TIMESHEETS}><Icon type="clock-circle-o" />Timesheets</Link></Menu.Item> }
  return
}
export const Maintenance = (role) => {
  if (role === 'client' || role === 'admin' || role === 'maintenance') {
    return (
      <Menu.Item key="/client-portal/maintenance/"><Link to={routes.MAINTENANCE}><Icon type="warning" />Maintenance</Link></Menu.Item>
    )
  }
}
export const Prestarts = (role) => {
  if (role === 'client' || role === 'admin' || role === 'maintenance') {
    return (
      <Menu.Item key="/client-portal/prestarts/"><Link to={routes.PRESTARTS}><Icon type="check-square-o" />Prestarts</Link></Menu.Item>
    )
  }
}

export const Misc = (user) => {
  if (user.role === 'admin' && user.username === 'Jim Alexander') {
    return (
      <SubMenu key='sub2' title={<span><Icon type="file" /><span>Misc</span></span>}>
        <Menu.Item key="/dev"><Link to={routes.DEVELOPER}>Developer</Link></Menu.Item>
        <Menu.Item key="/explosive-inv"><Link to={routes.EXPLOSIVEINV}>Explosives</Link></Menu.Item>
      </SubMenu>
    )
  }
}

// These nav footer components will be shown no matter the role
export const Role = role => {
  return (
    <Menu.Item key="6" id="menuRole" disabled>
      <Icon type="safety" />
      <span className="nav-text">{role}</span>
    </Menu.Item>
  )
}
export const Username = username => {
  return (
    <Menu.Item key="7" id="menuProfile">
      <Link to={routes.PROFILE}>
        <Icon type="user" />
        <span className="nav-text">{username}</span>
      </Link>
    </Menu.Item>
  )
}
export const Logout = () => {
  return (
    <Menu.Item key="8" id="menuLogout" onClick={() => {
      auth.doSignOut();
      ReactGA.event({
        category: 'user',
        action: 'User signed out'
      });
    }}>
      <Icon type="logout" />
      <span className="nav-text">Logout</span>
    </Menu.Item>
  )
}